import React, { Component } from 'react';
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {viewChanged} from "../../actions/OptionsActionsV2";
import {FormattedMessage} from "react-intl";
import {Capability, ViewType} from "../../enums";
import Select ,{SelectOption} from "@amzn/meridian/select";
import Text from "@amzn/meridian/text";
import {FEATURES} from "../../constants";
import {getNodeId, hasAmxlViewFlagEnabled} from "../../Utility";
class HeatMapViewOptionsV2 extends Component {
    render() {

        const {selectedView} = this.props;
        return (
            <div>
                <Text><FormattedMessage id="heatMapViewOptions.view" defaultMessage="View"/></Text>
                <Select onChange={updatedView => this.handleViewChange(updatedView)} value={selectedView} >
                    {!hasAmxlViewFlagEnabled(getNodeId(), this.props.featureStatus) &&
                        <SelectOption value={ViewType.DEFAULT_VIEW} data-cy={"heatMapFieldsetOption"} label={this.renderDefaultOption()}/>
                    }
                    <SelectOption value={ViewType.ROUTE_VIEW} data-cy={"heatMapFieldsetOption"} label={"Route"}/>
                    {this.isContainerPlanEnabled() &&
                        <SelectOption value={ViewType.REVERSE_SORT_GROUP_PLAN_VIEW} data-cy={"heatMapFieldsetOption"} label={"Reverse"}/>
                    }
                    {this.isSidelineVisibilityEnabled() &&
                        <SelectOption value={ViewType.SIDELINE_VIEW} data-cy={"heatMapFieldsetOption"} label={"Sideline"}/>
                    }
                </Select>
            </div>
        )
    }

    handleViewChange(updatedView) {
        this.props.dispatch(viewChanged(updatedView))
    }
    renderDefaultOption() {
        const capability = this.props.capability
        switch (capability) {
            case Capability.AR_NEXT_GEN:
                return "Station"
            case Capability.SSD:
                return "Zone"
            default:
                return "Cluster"
        }
    }

    isSidelineVisibilityEnabled() {
        return this.props.capability === Capability.AMZL && this.props.featureStatus &&
            this.props.featureStatus[FEATURES.SIDELINE_STOW_VISIBILITY];
    }

    isContainerPlanEnabled() {
        return this.props.featureStatus && this.props.featureStatus[FEATURES.CONTAINER_PLAN_ENABLED];
    }
}

const mapStateToProps = state => ({
    capability: state.optionsReducerV2.capability,
    selectedView: state.optionsReducerV2.heatMapView,
    featureStatus: state.configReducer.featureStatus
});
export default withRouter(connect(mapStateToProps)(HeatMapViewOptionsV2));


// WEBPACK FOOTER //
// ./src/components/options/HeatMapViewOptionsV2.js